module.exports = __webpack_public_path__ + "static/shawn-low-400w-103018-c536782f7ab5650994e9ac2624c19bcc.jpg";